import ECViewState from './viewStateHandler';
import { getListViewStore } from 'mini-mail-list-store/lib/store/Store';
import { getReadingPaneStore } from 'mini-mail-reading-pane-store/lib/store/Store';
import { getSelectedFolderNameOrId } from './getSelectedFolderNameOrId';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
export const getActiveReadingPanePath = (): string[] => {
    const route: string[] = [];
    const selectedFolderName = getSelectedFolderNameOrId();
    if (selectedFolderName) {
        route.push(selectedFolderName);
        // Reading pane route selection
        const readingPaneStore = getReadingPaneStore();
        if (ECViewState.shouldItemViewBeShown()) {
            if (readingPaneStore.itemReadingPaneViewState) {
                route.push('itemId');
                route.push(readingPaneStore.itemReadingPaneViewState.itemId);
            }
        } else {
            if (readingPaneStore.conversationReadingPaneViewState) {
                route.push('id');
                route.push(readingPaneStore.conversationReadingPaneViewState.conversationId);
                if (readingPaneStore.conversationReadingPaneViewState.itemId) {
                    route.push('itemId');
                    route.push(readingPaneStore.conversationReadingPaneViewState.itemId);
                    route.push('immutableItemId');
                    route.push(readingPaneStore.conversationReadingPaneViewState.itemId);
                }
            } else if (getListViewStore().shouldShowSearchBox) {
                route.push('id');
                route.push(getMailStore().mailModule.selectedId);
            }
        }
    }

    return route;
};
